import { render, staticRenderFns } from "./no_effect_appointments.vue?vue&type=template&id=6e160c02"
import script from "./no_effect_appointments.vue?vue&type=script&lang=js"
export * from "./no_effect_appointments.vue?vue&type=script&lang=js"
import style0 from "./no_effect_appointments.vue?vue&type=style&index=0&id=6e160c02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports